import { render, staticRenderFns } from "./audit-point.vue?vue&type=template&id=94096d50"
import script from "./audit-point.vue?vue&type=script&lang=js"
export * from "./audit-point.vue?vue&type=script&lang=js"
import style0 from "./audit-point.vue?vue&type=style&index=0&id=94096d50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports